import script from "./WhiteTransparentBubble.vue?vue&type=script&setup=true&lang=js"
export * from "./WhiteTransparentBubble.vue?vue&type=script&setup=true&lang=js"

import "./WhiteTransparentBubble.vue?vue&type=style&index=0&id=6c77318b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c77318b"]])

export default __exports__